import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {EncodeTagsPage} from './encode-tags';
import {ComponentsModule} from '../../components/components.module';
import {TranslateModule} from '@ngx-translate/core';
import {HeaderTitleComponentModule} from '../../components/header-title/header-title.module';

@NgModule({
  declarations: [
    EncodeTagsPage,
  ],
  imports: [
    IonicPageModule.forChild(EncodeTagsPage),
    TranslateModule.forChild(),
    ComponentsModule,
    HeaderTitleComponentModule,
  ],
})
export class EncodeTagsPageModule {

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/encode-tags/encode-tags.module.ts